
import { t } from 'i18next';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import { emailNotificationService } from '../../services/email-notification-service';
import React from 'react';
import { notificationDefinitionService } from '../../services/notification-definition-service';
import { providerService } from '../../services/provider-service';
import { emailMasterTemplateService } from '../../services/email-master-template';
import { createCustomStore } from '@/core/wrappers/custom-store-wrapper';



const EmailNotificationList = () => {
    const [mainStore] = useState(() => createCustomStore({
        key: "id",
        load: emailNotificationService.getListAsync,
        insert: emailNotificationService.createAsync,
        update: (key, values) => {
            return emailNotificationService.updateAsync(key, values);
        },
        remove: (key) => {
            return emailNotificationService.deleteAsync(`${key}`);
        },
    }));

    const [notificationDefinition] = useState(() => createCustomStore({
        key: 'id',
        load: notificationDefinitionService.getListAsync,
        byKey: (key, loadOptions: any) => {
            if (key) {
                loadOptions.filter = ["id", "=", key];
            }
        },
    }));

    const [providers] = useState(() => createCustomStore({
        key: 'id',
        load: providerService.getListAsync,
        byKey: (key, loadOptions) => {
            if (key) {
                loadOptions.filter = ["id", "=", key];
            }
        },
    }));

    const [emailMasterTemplate] = useState(() => createCustomStore({
        key: 'id',
        load: emailMasterTemplateService.getListAsync,
        byKey: (key, loadOptions: any) => {
            if (key) {
                loadOptions.filter = ["id", "=", key];
            }
        },
    }));

    const navigate = useNavigate();

    const goToEdit = (id: string) => {
        navigate(`/admin/email-notification-definition/${id}`, { state: { id: id } })
    }
    const handleRowUpdating = async (e: any) => {
        e.newData = { ...e.oldData, ...e.newData }
    };

    return (
        <React.Fragment>
            <DataGridWrapper
                props={{
                    id: 'email-notification-list', remoteOperations: true,

                    keyExpr: "id"
                }}
                permissonCode='Admin.Email.EmailNotification'
                datasource={mainStore}
                pagerVisible={true}
                headerFilterVisible={true}
                onRowUpdating={handleRowUpdating}
                enableCustomToolbarContent={false}
                columnChooser={false}
                editingConfig={{
                    allowAdding: true,
                    allowUpdating: true,
                    allowDeleting: true,
                }}
                columns={[
                    {
                        dataField: "id",
                        visible: false
                    },
                    {
                        dataField: 'groupCode',
                        caption: t('group_code'),
                        filtering: false,
                        allowSearch: false,
                        allowEditing: false
                    },
                    {
                        dataField: 'notificationDefinitionId',
                        caption: t('code'),
                        filtering: false,
                        allowSearch: false,
                        lookup: {
                            dataSource: notificationDefinition,
                            valueExpr: "id",
                            displayExpr: "code"
                        }
                    },
                    {
                        dataField: 'providerId',
                        caption: t('provider_name'),
                        filtering: false,
                        allowSearch: false,
                        lookup: {
                            dataSource: providers,
                            valueExpr: "id",
                            displayExpr: "name"
                        }
                    },
                    {
                        dataField: 'emailMasterTemplateId',
                        caption: t('email_master_template'),
                        filtering: false,
                        allowSearch: false,
                        lookup: {
                            dataSource: emailMasterTemplate,
                            valueExpr: "id",
                            displayExpr: "name"
                        }
                    },
                    {
                        dataField: 'retryCount',
                        caption: t('retry_count'),
                        filtering: false,
                        allowSearch: false,
                    },
                    {
                        dataField: 'priority',
                        caption: t('priority'),
                        filtering: false,
                        allowSearch: false,
                    },

                ]}
                buttonConfig={[
                    {
                        name: 'edit',
                        icon: 'edit',
                        onClick: (e: any) => goToEdit(e.row?.data.id),
                    },
                    {
                        name: 'delete',
                        icon: 'trash'
                    }
                ]}
            />
        </React.Fragment>
    )
}
export default EmailNotificationList